import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseNavLink',
    props: {
        href: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // If an href exists, render an <a> tag. Otherwise, render a <button>.
        const tag = computed(() => props.href ? 'a' : 'button');
        const __returned__ = { props, tag };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
